import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { TrendingUp } from 'lucide-react';

export function StreamerNormalizationIndicator({ 
  showNormalizationIndicator, 
  normalizationApplied, 
  isMinimized 
}) {
  return (
    <AnimatePresence>
      {showNormalizationIndicator && (
        <motion.div
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
          className={`absolute top-0 left-0 right-0 bg-gradient-to-r from-green-500/20 to-blue-500/20 backdrop-blur-sm border-b border-green-400/30 z-10 bg-black/80 ${
            isMinimized ? 'px-3 py-1' : 'px-4 py-2 rounded-t-lg'
          }`}
        >
          <div className={`flex items-center justify-center gap-2 ${isMinimized ? 'text-xs' : 'text-sm'}`}>
            <TrendingUp className={`text-green-400 ${isMinimized ? 'h-3 w-3' : 'h-4 w-4'}`} />
            <span className="text-green-400 font-medium">
              Volume Normalization Applied: {normalizationApplied}%
            </span>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}